
export const userConf = [
    {
        show: true,
        name: 'Profile',
        url: '#',
        class: 'dropdown-item d-flex align-items-center',
        icon: 'bx bx-user fs-5',
        action: 'profile'
    },
    {
        show: true,
        name: 'Settings',
        url: '/settings',
        class: 'dropdown-item d-flex align-items-center',
        icon: 'bx bx-cog fs-5',
        action: 'settings'
    }
]